import axios from "../utils/axios.wrapper";

export const getSuppliers = async () => {
  const { data } = await axios.get("/Supplier");
  return data.items || data;
};

export const getActiveSuppliers = async () => {
  const { data } = await axios.get("/Supplier/active");
  return data.items || data;
};

export const getInactiveSuppliers = async () => {
  const { data } = await axios.get("/Supplier/inactive");
  return data.items || data;
};

export const getSupplierById = async (id) => {
  const { data } = await axios.get(`/Supplier/${id}`);
  return data;
};

export const getSupplierByName = async (name) => {
  const { data } = await axios.get(`/Supplier/name/${name}`);
  return data;
};

export const getSupplierByEmail = async (email) => {
  const { data } = await axios.get(`/Supplier/email/${email}`);
  return data;
};

export const getSupplierByPhone = async (phone) => {
  const { data } = await axios.get(`/Supplier/phone/${phone}`);
  return data;
};

export const createSupplier = async (supplier) => {
  const { data } = await axios.post("/Supplier/create", supplier);
  return data;
};

export const updateSupplier = async (id, supplier) => {
  const { data } = await axios.put(`/Supplier/${id}`, supplier);
  return data;
};

export const deleteSupplier = async (id) => {
  const { data } = await axios.delete(`/Supplier/${id}`);
  return data;
};

export const hardDeleteSupplier = async (id) => {
  const { data } = await axios.delete(`/Supplier/hard/${id}`);
  return data;
};

export const importSuppliers = async (file) => {
  const formData = new FormData();
  formData.append('File', file);
  const { data } = await axios.post("/Supplier/import", formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return data;
};

export const downloadSupplierTemplate = async () => {
  const response = await axios.get("/Supplier/download-template", {
    responseType: 'blob',
  });
  return response;
};

export const supplierService = {
  getSuppliers,
  getActiveSuppliers,
  getInactiveSuppliers,
  getSupplierById,
  getSupplierByName,
  getSupplierByEmail,
  getSupplierByPhone,
  createSupplier,
  updateSupplier,
  deleteSupplier,
  hardDeleteSupplier,
  importSuppliers,
  downloadSupplierTemplate,
};